import { GetServerSideProps } from 'next'; // Assuming you are using Next.js
import PrizesPage from './index';
import React from 'react';
import { PrizeCategories, PrizeCore, PrizeTiers } from 'types/Prize';
import { prizeApiClient } from 'utils/apiClient';
import { MAIN_DRAW_SCHEDULE_NAME } from 'utils/constants';
import { MAIN_DRAW_PRIZE_TIERS } from 'constants/PrizeTiers';

interface IPrizeFilterPage {
  prizes: PrizeCore[];
  prizeCategories: PrizeCategories;
  prizeTiers: PrizeTiers;
  categoryFilter: string;
}

const PrizesPageForFilterId: React.FC<IPrizeFilterPage> = ({
  prizes,
  prizeCategories,
  prizeTiers,
  categoryFilter,
}) => {
  return (
    <PrizesPage
      prizes={prizes}
      prizeCategories={prizeCategories}
      prizeTiers={prizeTiers}
      categoryFilter={categoryFilter}
    />
  );
};

export const getServerSideProps: GetServerSideProps<IPrizeFilterPage> = async ({
  res,
  params,
}) => {
  res.setHeader(
    'Cache-Control',
    'public, max-age=3600, s-maxage=3600, stale-while-revalidate=59'
  );

  let prizes: PrizeCore[] = [];
  const prizesResp = await prizeApiClient.public.getAllAvailablePrizes({
    query: { drawSchedule: MAIN_DRAW_SCHEDULE_NAME },
  });

  switch (prizesResp.status) {
    case 200:
      prizes = prizesResp.body.filter(
        ({ tierCode }) => tierCode in MAIN_DRAW_PRIZE_TIERS
      );
      break;
    default:
      console.error(`Error fetching prizes`);
      return {
        notFound: true,
      };
  }

  let prizeCategories = {};
  const categoriesResp = await prizeApiClient.public.getCategories();

  switch (categoriesResp.status) {
    case 200:
      prizeCategories = categoriesResp.body;
      break;
    case 404:
      console.error(
        `Error fetching prize categories: ${categoriesResp.body.message}`
      );
      break;
  }

  let prizeTiers: PrizeTiers = [];
  const tiersResp = await prizeApiClient.public.getAvailablePrizeTiers({
    query: { drawSchedule: MAIN_DRAW_SCHEDULE_NAME },
  });

  switch (tiersResp.status) {
    case 200:
      prizeTiers = tiersResp.body.filter(
        (tierCode) => tierCode in MAIN_DRAW_PRIZE_TIERS
      );
      break;
    case 404:
      console.error(`Error fetching prize tiers: ${tiersResp.body.message}`);
      break;
  }

  return {
    props: {
      prizes,
      prizeTiers,
      prizeCategories,
      categoryFilter: (params?.filter as string) ?? null,
    },
  };
};

export default PrizesPageForFilterId;
